// import { Social } from "Utils/Constants/Social";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Tooltip from '@mui/material/Tooltip';
import GetIcon from "Utils/Helpers/GetIcon";

export default function HomeSocial() {
  const { social } = useSelector((state) => ({
    social: state.data.social,
  }));
  return (
    <div className="social-home">
      <div className="social inner-home">
        {social && social.infos.map((i, index) => {
          return (
            <Tooltip title={i.name} key={"home-social" + index}>
              <Link to={i.link} target="_blank">
                <GetIcon iconKey={i.icon} />
              </Link>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
}
